import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Corrected path

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    // If no user is logged in, redirect to the home page
    return <Navigate to="/" />;
  }

  return children; // If logged in, show the component
};

export default ProtectedRoute;
